var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#2B2D30"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13417_31311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 30.3333V29L36 21H22.6667C21.1867 21 20 22.1867 20 23.6667V42.3333C20 43.0406 20.281 43.7189 20.781 44.219C21.2811 44.719 21.9594 45 22.6667 45H30.6667V42.5067L41.8533 31.32C42.44 30.7333 43.1867 30.4133 44 30.3333ZM34.6667 23L42 30.3333H34.6667V23ZM46.4667 35.92L45.16 37.2267L42.44 34.5067L43.7467 33.2C44 32.9333 44.44 32.9333 44.7067 33.2L46.4667 34.96C46.7333 35.2267 46.7333 35.6667 46.4667 35.92ZM41.5067 35.44L44.2267 38.16L36.0533 46.3333H33.3333V43.6133L41.5067 35.44Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13417_31311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16.5 16.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.7c50b9aaeb4e8e88675d32aba4cec449.svg";
export { ForwardRef as ReactComponent };